'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

var _bMenuEItemMTypeLink = (require('./../../menu/__item/menu__item.react.js'), require('./../../../desktop.blocks/menu/__item/menu__item.react.js'), (require('./../../menu/__item/_type/menu__item_type_link.react.js').default || require('./../../menu/__item/_type/menu__item_type_link.react.js')).applyDecls());

var _bMenuEItemMTypeLink2 = _interopRequireDefault(_bMenuEItemMTypeLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = (0, _iBem.decl)(_bMenuEItemMTypeLink2.default, {
    block: 'user2',
    elem: 'menu-item',
    mix: function mix(_ref) {
        var action = _ref.action;

        return [].concat(_toConsumableArray(this.__base.apply(this, arguments) || []), [{ block: 'menu', elem: 'item', mods: { type: 'link', hovered: this.__self.bool2string(this.state.hovered) } }]);
    },
    attrs: function attrs(_ref2) {
        var onClick = _ref2.onClick;

        return _extends({}, this.__base.apply(this, arguments), {
            onClick: onClick,
            href: this.url,
            tabIndex: '0'
        });
    }
}, {
    propTypes: {
        action: _propTypes2.default.string,
        type: _propTypes2.default.string,
        isNavigation: _propTypes2.default.bool
    },
    defaultProps: {
        isNavigation: true,
        type: 'link'
    }
});